import React, { useMemo } from 'react';
import styles from './BackgroundElements.module.scss';
import { getImageFromS3 } from '../../../../imageService';

const BackgroundElements = () => {
  const elements = useMemo(() => {
    return [
      {
        id: 1,
        type: 'flower1',
        animClass: 'animTriangle',
        style: {
          top: '-140px',
          left: '-70px',
          width: '352px',
          zIndex: 1,
          filter: 'blur(8px)',
          '--tx': '140px',
          '--ty': '40px',
          '--path-rot': '45deg',
          '--rot': '35deg',
          '--start-rot': '20deg',
          '--duration': '25s'
        }
      },
      {
        id: 2,
        type: 'flower2',
        animClass: 'animRhombus',
        style: {
          top: '197px',
          right: '-70px',
          width: '224px',
          '--tx': '40px',
          '--ty': '40px',
          '--rot': '-20deg',
          '--duration': '20s'
        }
      },
      {
        id: 3,
        type: 'flower3',
        animClass: 'animRhombus',
        style: {
          top: '346px',
          left: '-70px',
          width: '160px',
          '--ty': '40px',
          '--rot': '100deg',
          '--duration': '30s'
        }
      },
      {
        id: 4,
        type: 'flower4',
        animClass: 'animRhombus',
        style: {
          top: '687px',
          left: '-50px',
          width: '171px',
          filter: 'blur(2px)',
          opacity: '0.7',
          '--ty': '60px',
          '--rot': '-15deg',
          '--duration': '15s'
        }
      },
      {
        id: 5,
        type: 'flower5',
        animClass: 'animTriangle',
        style: {
          top: '937px',
          right: '-140px',
          width: '288px',
          filter: 'blur(2px)',
          opacity: '0.5',
          '--tx': '10px',
          '--ty': '100px',
          '--path-rot': '-45deg',
          '--rot': '45deg',
          '--duration': '20s'
        }
      },
      {
        id: 6,
        type: 'flower6',
        animClass: 'animTriangle',
        style: {
          bottom: '-50px',
          left: '-145px',
          width: '288px',
          filter: 'blur(2px)',
          opacity: '0.5',
          '--tx': '50px',
          '--ty': '50px',
          '--rot': '-30deg',
          '--duration': '20s'
        }
      }
    ];
  }, []);

  return (
    <div className={styles.backgroundContainer}>
      {elements.map((el) => (
        <img
          key={el.id}
          src={getImageFromS3(`images/26ua-kv3/${el.type}.png`)}
          className={`${styles.element} ${styles[el.animClass]}`}
          style={el.style}
          alt={el.type}
        />
      ))}
    </div>
  );
};

export default BackgroundElements;
